<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('service-details-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn flat icon slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator" @click="OpenReport()">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>
                <v-flex mb-3 md4 px-2>
                    <v-btn @click="OpenReport2()">
                        {{   $t('Print-Translate-Details') }}
                    </v-btn>
                </v-flex>
            </div>
            <!-- ServiceDetails -->
            <div class="text-xs-right">
                <v-btn :to="{ name: 'add-service-details' }" color="success" v-can:add>
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-service-details') }}
                </v-btn>
                <v-menu bottom left min-width="100" origin="center center" transition="scale-transition" v-if="selected.length">
                    <v-btn flat icon slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteServiceDetails" v-can:delete>
                            <v-list-tile-title>Delete</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postServiceDetails" v-can:post>
                            <v-list-tile-title>Post</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostServiceDetails" v-can:unpost>
                            <v-list-tile-title>Unpost</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Search box -->
        <v-flex xs12>
            <v-card class="pa-3 mb-3">
                <v-layout wrap>
                    <!--<v-flex xs12>
                        <v-text-field :label="$t('search')"
                                      @change="getServiceDetailsByCriteria"
                                      append-icon="mdi-magnify"
                                      hide-details
                                      single-line
                                      v-model="keyword"></v-text-field>
                    </v-flex>-->
                    <v-flex md2 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('select-gender')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="gendersList"
                                        :label="$t('select-gender')"
                                        :name="'gender'"
                                        clearable
                                        item-value="code"
                                        v-model="gender"></v-autocomplete>
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-2>
                        <v-text-field :label="$t('national-number')" @change="getServiceDetailsByCriteria" v-model="beneficiaryNationalNumJOR"></v-text-field>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="fromDateMenu">
                            <v-text-field :data-vv-as="$t('from-date')"
                                          :error-messages="errors.collect('fromDate')"
                                          :label="$t('from-date-creation')"
                                          clearable
                                          name="fromDate"
                                          prepend-icon="event"
                                          readonly
                                          slot="activator"
                                          v-model="fromDate"></v-text-field>
                            <v-date-picker :min="'1900-01-01'"
                                           :max="''"
                                           @change="fromDateMenu = false"
                                           ref="picker"
                                           v-model="fromDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="toDateMenu">
                            <v-text-field :data-vv-as="$t('to-date')"
                                          :error-messages="errors.collect('toDate')"
                                          :label="$t('to-date-creation')"
                                          clearable
                                          name="toDate"
                                          prepend-icon="event"
                                          readonly
                                          slot="activator"
                                          v-model="toDate"></v-text-field>
                            <v-date-picker :min="'1900-01-01'"
                                           @change="toDateMenu = false"
                                           ref="picker"
                                           v-model="toDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('governorate')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="governoratesList"
                                        :label="$t('governorate')"
                                        clearable
                                        item-value="code"
                                        name="governorate"
                                        v-model="governorate"></v-autocomplete>
                    </v-flex>
                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('city')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="citiesList"
                                        :label="$t('city')"
                                        clearable
                                        item-value="code"
                                        name="city"
                                        v-model="city"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn color="primary" type="submit" @click="getServiceDetailsByCriteria()">{{ $t('filter') }}</v-btn>
                        <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          :headers="headers"
                          :items="serviceDetails"
                          :loading="isLoading"
                          class="elevation-1"
                          select-all
                          v-model="selected">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.createdat | date }}</td>
                        <td>{{ props.item.beneficiaryNationalNumJOR }}</td>
                        <td>{{ props.item.fullName }}</td>
                        <td>{{ props.item.universityName }}</td>
                        <td>{{ props.item.year }}</td>
                        <td>{{ tableFormat('SemesterList',props.item.semester) }}</td>
                        <td>
                            <v-btn icon
                                   v-can:edit
                                   :to="{
                  name: 'edit-service-details',
                  params: { beneficiaryInformationId: props.item.beneficiaryInfoId, id: props.item.id }
                }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <!--<td>
                            <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
                            <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
                        </td>-->
                    </tr>
                </template>
            </v-data-table>
            <v-btn color="primary" type="reset" @click="deleteServiceDetails()">{{ $t('delete') }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import ServiceDetailsService from '@/services/Disabilities/PersonWithDisabilities/SignLanguageTranslationService/ServiceDetailsService';
    import LookUpService from '@/services/LookUpService';
    import SettingOrgService from "@/services/AdminSystem/OrganizationStructure/SettingOrgService";

    export default {
        name: 'service-details',
        data() {
            return {
                serviceDetails: [],
                selected: [],
                SemesterList: [],
                citiesList: [],
                gendersList: [],
                governoratesList: [],
                keyword: '',
                beneficiaryNationalNumJOR: '',
                isLoading: false,
                fromDate: null,
                toDate: null,
                governorate: '',
                city: '',
                gender: 0,
                fromDateMenu: false,
                toDateMenu: false,
            };
        },
        async created() {
            this.$store.dispatch('showLoading');
            await this.getServiceDetailsByCriteria();
            await this.getGovernorates();
            await this.getCities();
            await this.getSemester();
            await this.getGenders();
            this.$store.dispatch('hideLoading');
        },
        methods: {
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getGenders() {
                this.gendersList = (await LookUpService.getLookup(59)).data;
            },
            async getCities() {
                this.citiesList = (await LookUpService.getLookup(100)).data;
            },
            async getSemester() {
                this.SemesterList = (await LookUpService.getLookup(224)).data;
            },
            tableFormat(arrayName, code) {
                const item = this[arrayName].find(item => item.code === code);
                return item ? item.name : code;
            },
            /* Get all Service Details info */
            async getServiceDetailsByCriteria() {
                this.isLoading = true;

                const serviceDetails = (await ServiceDetailsService.getServiceDetailsByCriteria({
                    keyword: this.keyword,
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR,
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    governorate: this.governorate,
                    city: this.city,
                    gender:this.gender,
                })).data;
                this.serviceDetails = serviceDetails;
                this.isLoading = false;
            },
            async  filterInit() {
                this.keyword = '';
                this.beneficiaryNationalNumJOR = '';
                this.fromDate = null;
                this.toDate = null;
                this.governorate = '';
                this.city = '';
                this.gender = '0';
                this.getServiceDetailsByCriteria();
            },
            /* Delete Service Details */
            deleteServiceDetails() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete ServiceDetails */
                    this.$store.dispatch('showLoading');
                    const result = await ServiceDetailsService.deleteServiceDetails(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    await this.getServiceDetailsByCriteria();
                });
            },

            /* Post Service Details */
            async postServiceDetails() {
                let postServiceDetails = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postServiceDetails.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await ServiceDetailsService.postServiceDetails(postServiceDetails);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getServiceDetailsByCriteria();
            },

            /* Un Post Service Details */
            async unpostServiceDetails() {
                let postServiceDetails = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postServiceDetails.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await ServiceDetailsService.postServiceDetails(postServiceDetails);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getServiceDetailsByCriteria();
            },
            async   OpenReport() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/Sign.aspx', '_blank');
                }
            },
            async   OpenReport2() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/TranslatorDetails.aspx?fromdate=' + this.fromDate +
                        '&toDate=' + this.toDate, '_blank');
                }
            },
        },
        computed: {
            selectedIds() {
                return this.selected.map(serviceDetails => ({ id: serviceDetails.id }));
            },

            /* Query Tabel */
            headers() {
                return [
                    { text: this.$t('request-date'), value: 'createdat', sortable: false },
                    {
                        text: this.$t('beneficiary-nationalNumJOR'),
                        value: 'beneficiaryNationalNumJOR',
                        sortable: false
                    },
                    {
                        text: this.$t('full-name'),
                        value: 'fullName',
                        sortable: false
                    },
                    {
                        text: this.$t('university'),
                        value: 'universityName',
                        sortable: false
                    },
                    {
                        text: this.$t('year'),
                        value: 'year',
                        sortable: false
                    },
                    {
                        text: this.$t('semester'),
                        value: 'semester',
                        sortable: false
                    },
                    { text: this.$t('edit'), value: '', sortable: false },
                    //{ text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            }
        }
    };
</script> 